import{createContext as r,useContext as e}from"react";var t=function(t){var i=r(t);return[function(){var r=e(i);if(!r)throw new Error("useCtx must be inside a Provider with a value");return r},i.Provider]};export{t as createCtx};
//# sourceMappingURL=context.mjs.map
